import React from "react";
import Sidebar from "../components/common/Sidebar";
import "./About.css";

const aboutParagraphs = [
  'Inspired by his Father Shantilal Dhanjibhai Soni, Vinubhai Soni established "Vs Jewellery Castings" over three decades ago in Nadiad, a city in the western India state of Gujarat. As the business grew gradually, expanding to new horizons was the need of the times.',
  'It was then that his son Rushi Soni, Priyansh Soni and Jaymin soni commenced operations in Nadiad under the able supervision of Vinubhai S.Soni, "VS JewelCast" was born with the establishment of Jewellery Casting firm in Baroda city as a branch office. Since then, "VS JewelCast" has come a long way in achieving its status of being one of the most trusted names in this glittering business of jewellery manufacturing & Casting Process.',
  "As the Technology emerging in Jewellery Business, CAD/CAM Designing & Rapid Prototyping of the Master Model Produced through '3D Printer'. \"VS Jewelcast\" takes pride in our modern design studio complete with a state-of-the-art CAD facility. Our dedicated team of designer is, well versed on the latest Indian & International trends and contributes at least 50 to 70 innovative designs monthly to our ever-expanding portfolio of Master Models. The majority of our current models are produced using CAD/CAM to ensure precision.",
];

export default function About() {
  return (
    <>
      <Sidebar showNewsFooter={false} />
      <main className="content-area">
        <section className="about-panel">
          {/* Header bar – identical to sidebar section-title style */}
          <div className="about-header-container">
            <div className="title-white">About Us</div>
          </div>

          {/* Dark content box matching reference #1d0e25 */}
          <div className="about-body">
            {aboutParagraphs.map((paragraph, idx) => (
              <p key={idx}>{paragraph}</p>
            ))}
          </div>
        </section>
      </main>
    </>
  );
}
